/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useContext, useEffect, useRef } from "react";
import { Loader } from "@progress/kendo-react-indicators";
import {
  Grid,
  GridColumn as Column,
  getSelectedState,
} from "@progress/kendo-react-grid";
import { getter, process } from "@progress/kendo-data-query";
import { CirclePlus, CircleX, SlidersHorizontal } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  cn,
  Combobox,
  DatePicker,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@repo/ui";
import { UserContext } from "utils/reducers/user";
import Layout from "components/layout";
import {
  useGetCDMList,
  useGetCustomers,
  useGetShiftRoutes,
} from "utils/apis/lookups.api";
import { isOperationAllowed, readOnlyExcelDate, showToast } from "utils/helper";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";
import { formatDate } from "date-fns";
import {
  useAssignClearanceRoute,
  useCancelClearanceService,
  useCreateClearanceBulkOrders,
  useGetClearanceRequests,
} from "utils/apis/clearance.api";
import { Permissions } from "utils/enums";
import { saveFilters } from "utils/actions/user";
import { ExcelExport } from "@progress/kendo-react-excel-export";

const pageSize = 25;

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export default function Clearance() {
  const currentDate = new Date();
  const user = useContext(UserContext);

  let excelExport1: ExcelExport | null;

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [routesTeams, setRoutesTeams] = useState<any[]>([]);
  const [selectedState, setSelectedState] = useState<any>({});
  const DATA_ITEM_KEY = "requestId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<any>(user?.filters?.clearance || {});

  const [ddlInRouteTeams, setDdlInRouteTeams] = useState("");
  const [selectedRequests, setSelectedRequests] = useState([]);

  const [btnAssignRouteDis, setBtnAssignRouteDis] = useState(true);
  const [btnAssignRouteTxt, setBtnAssignRouteTxt] = useState("Assign Route");
  const [btnCancelDis, setBtnCancelDis] = useState(true);
  const [btnCancelTxt, setBtnCancelTxt] = useState("Cancel");

  const { data: cdmLocations } = useGetCDMList(filters?.customer?.id);
  const { data: customers } = useGetCustomers();
  const { data: inRouteTeams } = useGetShiftRoutes({
    cashCenterId: user.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const {
    isSuccess: requestSuccess,
    data: requestsData,
    isPending: loadingRequests,
  } = useGetClearanceRequests({
    pageNumber: currentPage || 1,
    pageRowCount: pageSize,
    searchCriteria:
      filters?.searchCriteria?.id.length >= 3
        ? filters?.searchCriteria?.id
        : "",
    operationDate: formatDate(
      filters?.operationDate?.id || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
    cashCenterId: user.CashCenterId,
    customerId: filters?.customer?.id || "",
    onwardSPId: filters?.location?.id || "",
  });

  const {
    mutate: createBulkOrders,
    isSuccess: bulkOrderSuccess,
    isError: bulkOrderError,
    data: bulkCreationResponseData,
  } = useCreateClearanceBulkOrders();

  const {
    mutate: cancelService,
    isSuccess: cancelSuccess,
    isError: cancelError,
  } = useCancelClearanceService();

  const {
    mutate: assignRoute,
    isSuccess: assignRouteSuccess,
    isError: assignRouteError,
  } = useAssignClearanceRoute();

  const routesTeamsList = useRef<any[]>([]);

  useEffect(() => {
    if (requestSuccess && requestsData?.data) {
      setTotalRecords(requestsData?.totalRecords);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestSuccess, requestsData?.data]);

  useEffect(() => {
    if (bulkOrderSuccess) {
      setOpenFileUpload(false);
      setRoutesTeams([]);
    }
    if (bulkOrderError) {
      setOpenFileUpload(false);
      setRoutesTeams([]);
    }
  }, [bulkOrderSuccess, bulkOrderError]);

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(user.dispatch, {
      ...user.filters,
      clearance: updatedFilter,
    });
  };

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedJobs = selections.filter((req) => req.isSelected === true);

    const requestIds: any = selectedJobs.map((req) => ({
      itemKey: req.itemKey,
    }));

    setSelectedRequests(requestIds);

    if (requestIds.length > 0) {
      setBtnCancelDis(false);
      if (ddlInRouteTeams) setBtnAssignRouteDis(false);
      else setBtnAssignRouteDis(true);
    } else {
      setBtnAssignRouteDis(true);
      setBtnCancelDis(true);
    }
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState).map((key) => ({
      itemKey: key,
      isSelected: newSelectedState[key],
    }));

    const selectedRequests = selections.filter(
      (req) => req.isSelected === true,
    );

    const requestIds: any = selectedRequests.map((req) => ({
      itemKey: req.itemKey,
    }));

    setSelectedRequests(requestIds);

    if (requestIds.length > 0) {
      setBtnCancelDis(false);
      if (ddlInRouteTeams) setBtnAssignRouteDis(false);
      else setBtnAssignRouteDis(true);
    } else {
      setBtnAssignRouteDis(true);
      setBtnCancelDis(true);
    }
  };

  const fileHandler = (event: any) => {
    const fileObj = event.target.files[0] as File | null;
    if (!fileObj) return;
    if (
      ![
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "csv",
      ].includes(fileObj.type)
    )
      return showToast("error", "File formate not supported.");
    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", err);
      } else {
        routesTeamsList.current = [];

        const rows = resp?.rows || [];
        if (!rows.length) {
          showToast("error", "Excel file is empty.");
          return;
        }

        // parse each data row starting from 2nd row (index 1)
        for (let idx = 1; idx < rows.length; idx += 1) {
          const row = rows[idx] || [];
          // skip entirely empty rows
          const allEmpty = row.every(
            (c: any) =>
              c === null || c === undefined || String(c).trim() === "",
          );
          if (allEmpty) continue;

          const sourceBarcode = row[0];
          const onwardBarcode = row[1];
          const serviceDate = row[2];
          const invoicingModel = row[3];
          const jobNature = row[4];
          const jobType = row[5];
          const priority = row[6];
          const routeNo = row[7];
          const requestedBy = row[8];
          // skip if both barcodes  is missing
          if (!sourceBarcode && !onwardBarcode) continue;

          routesTeamsList.current.push({
            sourceBarcode: String(sourceBarcode || "").trim(),
            onwardBarcode: String(onwardBarcode || "").trim(),
            serviceDate: readOnlyExcelDate(serviceDate),
            invoicingModel,
            priority,
            jobType,
            jobNature,
            routeNo,
            shift: "morning",
            requestedBy,
          });
        }

        if (routesTeamsList.current.length > 0) {
          setRoutesTeams([...routesTeamsList.current]);
        } else {
          showToast("error", "No data found in excel file.");
        }
      }
    });
  };

  const onPageChange = (e: any) => {
    const _currentPage = e.page.skip / e.page.take + 1;
    setCurrentPage(_currentPage);
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };

  const onOperationDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        operationDate: {
          name: formatDate(value, "PPP"),
          id: value,
        },
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        clearance: {
          ...filters,
          operationDate: {
            name: formatDate(value, "PPP"),
            id: value,
          },
        },
      });
    }
    setCurrentPage(1);
  };

  const onFilterSearch = (e: any) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      searchCriteria: {
        name: e.target.value,
        id: e.target.value,
      },
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      clearance: {
        ...filters,
        searchCriteria: {
          name: e.target.value,
          id: e.target.value,
        },
      },
    });
  };

  const handleFiltersUpdate = (key: string, val: any) => {
    const { location, ...remainingFilters } = filters;
    setFilters({
      ...(key === "customer" ? remainingFilters : filters),
      [key]: JSON.parse(val),
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      clearance: {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(val),
      },
    });
  };

  const handleCustomer = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("customer", val);
  };

  const handleLocationFilter = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("location", val);
  };

  const onConfirmFileOrders = () => {
    createBulkOrders(routesTeams);
  };

  const onDdlInRouteTeamsChanged = (value: string) => {
    if (!value) {
      setDdlInRouteTeams("");
      return;
    }

    setDdlInRouteTeams(value);

    if (selectedRequests.length > 0) setBtnAssignRouteDis(false);
    else setBtnAssignRouteDis(true);
  };

  const onBtnAssignRouteClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to assign route.");
      return;
    }

    if (!ddlInRouteTeams) {
      showToast("error", "Please select route to assign.");
      return;
    }

    const cashCenterId = user.CashCenterId;
    const routeNo = ddlInRouteTeams;

    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1],
    }));

    const assignmentDto: any = {
      cashCenterId,
      operationDate: formatDate(
        filters?.operationDate?.id || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo,
      shift: "morning",
      requests: requestsIds,
    };

    setBtnAssignRouteDis(true);
    setBtnAssignRouteTxt("Assigning...");
    assignRoute(assignmentDto);
  };

  const onBtnCancelClicked = () => {
    if (selectedRequests.length === 0) {
      showToast("error", "No job selected to assign route.");
      return;
    }

    setBtnCancelDis(true);
    setBtnCancelTxt("Canceling...");

    const requestsIds = selectedRequests.map((sr: any) => ({
      requestId: sr.itemKey.split("_")[0],
      jobNo: sr.itemKey.split("_")[1],
    }));

    cancelService(requestsIds);
  };

  function ShowDetailsButtonCell(props: any) {
    const { requestId, jobNo, orderId } = props.dataItem;
    return (
      <td
        className="text-center"
        {...props}
        onClick={(e: Event) => {
          e.stopPropagation();
          props.selectionChange(props.dataItem);
        }}
      >
        {isOperationAllowed(Permissions.Clearance, Permissions.View) ? (
          <Link
            to="/clearance-detail"
            state={{
              requestId,
              jobNo,
            }}
          >
            {orderId}
          </Link>
        ) : (
          orderId
        )}
      </td>
    );
  }

  useEffect(() => {
    if (cancelSuccess) {
      setBtnCancelDis(true);
      setBtnCancelTxt("Cancel");
      setSelectedState({});
    }
    if (cancelError) {
      setBtnCancelDis(false);
      setBtnCancelTxt("Cancel");
    }
  }, [cancelError, cancelSuccess]);

  useEffect(() => {
    if (assignRouteSuccess) {
      setDdlInRouteTeams("");
      setBtnAssignRouteTxt("Assign Route");
      setSelectedState({});
    }
    if (assignRouteError) {
      setBtnAssignRouteDis(false);
      setBtnAssignRouteTxt("Assign Route");
    }
  }, [assignRouteError, assignRouteSuccess]);

  useEffect(() => {
    if (bulkCreationResponseData?.length) {
      excelExport1?.save(bulkCreationResponseData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkCreationResponseData]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Clearance </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="secondary"
                    className="p-2"
                    title="Apply Filters"
                  >
                    <SlidersHorizontal className="" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent align="start" className="w-[600px]">
                  <h6 className="font-semibold text-lg">Apply Filters</h6>
                  <div className="grid grid-cols-2 gap-4 mt-3">
                    <Combobox
                      placeholder="Select Customer"
                      value={JSON.stringify(filters?.customer) || ""}
                      data={customers?.map((item) => ({
                        value: JSON.stringify({
                          name: item.name,
                          id: item.customerId,
                        }),
                        label: item.name,
                      }))}
                      setValue={handleCustomer}
                    />
                    <Combobox
                      value={JSON.stringify(filters?.location) || ""}
                      placeholder="Select Location"
                      data={cdmLocations?.map((item) => ({
                        value: JSON.stringify({
                          name: `${item.barcode}-${item.locationId}`,
                          id: item?.servicePointId,
                        }),
                        label: `${item.barcode}-${item.locationId}`,
                      }))}
                      setValue={handleLocationFilter}
                    />
                  </div>
                </PopoverContent>
              </Popover>
              <div className="w-[15%]">
                <DatePicker
                  placeholder="Select Operation Date"
                  selectedDate={filters?.operationDate?.id || currentDate}
                  onSelectDate={onOperationDateChanged}
                />
              </div>
              {isOperationAllowed(Permissions.Clearance, Permissions.Edit) ? (
                <div className="w-[15%]">
                  <Combobox
                    setValue={onDdlInRouteTeamsChanged}
                    value={ddlInRouteTeams}
                    placeholder="Select Route"
                    data={inRouteTeams?.map((item: any) => ({
                      value: item?.routeNo,
                      label: `${item.routeNo} (${item.description})`,
                    }))}
                  />
                </div>
              ) : null}

              <div className="w-[10%]">
                {loadingRequests ? (
                  <div className="text-end">
                    <Loader size="large" type="pulsing" />
                  </div>
                ) : null}
              </div>

              <div className="flex-1 flex justify-end gap-2">
                {isOperationAllowed(Permissions.Clearance, Permissions.Add) ? (
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="secondary" className="gap-2">
                        <CirclePlus />
                        Create Request
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-[180px]">
                      <DropdownMenuItem>
                        <Link
                          to="/create-clearance"
                          state={{ createType: "single" }}
                        >
                          Single Request
                        </Link>
                      </DropdownMenuItem>
                      {/* <DropdownMenuItem>
                        <Link
                          to="/create-clearance"
                          state={{ createType: "multiple" }}
                        >
                          Multiple Requests
                        </Link>
                      </DropdownMenuItem> */}
                      <DropdownMenuItem
                        onClick={() => {
                          setOpenFileUpload(true);
                        }}
                        className="cursor-pointer"
                      >
                        Bulk Requests
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                ) : null}
                {isOperationAllowed(Permissions.Clearance, Permissions.Edit) ? (
                  <Button
                    variant="secondary"
                    disabled={btnAssignRouteDis}
                    onClick={onBtnAssignRouteClicked}
                  >
                    {btnAssignRouteTxt}
                  </Button>
                ) : null}
                {/* {isOperationAllowed(
                  Permissions.Clearance,
                  Permissions.Cancel,
                ) ? ( */}
                <Button
                  variant="secondary"
                  disabled={btnCancelDis}
                  onClick={onBtnCancelClicked}
                >
                  {btnCancelTxt}
                </Button>
                {/* ) : null} */}
              </div>
            </div>
            <div className="flex gap-2 flex-wrap mb-3 items-center">
              {Object.entries(filters).map(([key, val]: any, i) => (
                <Badge
                  variant="secondary"
                  className="gap-3 pr-1 cursor-pointer"
                  key={i}
                >
                  {val?.name}{" "}
                  <CircleX
                    onClick={() => {
                      handleClearFilter(key);
                    }}
                  />
                </Badge>
              ))}
            </div>
            <div className="border-b mb-3 bg-accent" />
            {isOperationAllowed(Permissions.Clearance, Permissions.Search) ? (
              <Input
                className="max-w-[420px] w-full ml-auto mb-3"
                value={filters?.searchCriteria?.id}
                onChange={onFilterSearch}
                title="Search: Job No., Job Nature, Status, Route No., Shift"
                placeholder="Search: Job No., Job Nature, Status, Route No., Shift"
              />
            ) : null}
            <Grid
              className="text-xs"
              dataItemKey={DATA_ITEM_KEY}
              selectedField={SELECTED_FIELD}
              selectable={{
                enabled: true,
                drag: true,
                cell: false,
                mode: "multiple",
              }}
              data={process(
                requestsData?.data?.map((req: any) => ({
                  ...req,
                  [SELECTED_FIELD]: selectedState[idGetter(req)],
                })) || [],
                {
                  ...dataState,
                  skip: 0,
                },
              )}
              {...dataState}
              pageable
              onPageChange={onPageChange}
              pageSize={pageSize}
              total={totalRecords}
              skip={(currentPage - 1) * pageSize}
              take={pageSize}
              onDataStateChange={onDataStateChange}
              sortable
              filterable
              onSelectionChange={onSelectionChange}
              onHeaderSelectionChange={onHeaderSelectionChange}
              size="small"
            >
              <Column
                field={SELECTED_FIELD}
                filterable={false}
                width="40px"
                headerSelectionValue={
                  requestsData?.data?.findIndex(
                    (item: any) => !selectedState[idGetter(item)],
                  ) === -1
                }
              />
              <Column
                field="orderId"
                title="Order Id"
                cell={ShowDetailsButtonCell}
                width={160}
              />
              <Column
                title="Job #"
                width={80}
                field="jobNo"
                headerClassName="text-center"
              />
              <Column field="customer" title="Customer" width={240} />
              <Column field="barcode" title="Barcode" width={240} />
              <Column field="locationId" title="Location Id" width={240} />
              <Column field="locationName" title="Location Name" width={280} />
              <Column
                field="routeNo"
                title="Route"
                className="text-center"
                headerClassName="text-center"
                width={180}
              />
              <Column
                field="jobNature"
                title="Job Nature"
                width={140}
                className="text-center"
                headerClassName="text-center"
              />

              <Column
                field="jobType"
                title="Job Type"
                width={140}
                className="text-center"
                headerClassName="text-center"
              />

              <Column
                width={140}
                field="status"
                title="Status"
                className="text-center"
                headerClassName="text-center"
              />
              <Column field="requestedBy" title="Requested By" width={140} />
              <Column
                field="remarks"
                title="Remarks"
                headerClassName={cn("max-w-md w-48")}
                className={cn("max-w-md w-48")}
              />
            </Grid>
            <ExcelExport
              ref={(exporter) => {
                excelExport1 = exporter;
              }}
              fileName={`Clearance_Bulk_Orders_${new Date().toLocaleString()}.xlsx`}
              columns={[
                { field: "sourceBarcode", title: "Source Barcode" },
                { field: "onwardBarcode", title: "Onward Barcode" },
                {
                  field: "invoicingModel",
                  title: "Invoicing Model",
                },
                { field: "jobType", title: "Job Type" },
                { field: "jobNature", title: "Job Nature" },
                { field: "routeNo", title: "Route No" },
                { field: "priority", title: "Priority" },
                { field: "serviceDate", title: "Service Date" },
                { field: "requestedBy", title: "Requested By" },
                { field: "status", title: "Status" },
                { field: "message", title: "Message" },
              ]}
            />
          </CardDescription>
        </CardContent>
      </Card>
      <Dialog open={openFileUpload} onOpenChange={setOpenFileUpload}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upload Orders</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {routesTeams?.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-5 text-gray-500 dark:text-gray-400">
                  File uploaded successfully!. Now add orders.
                </p>
                <Button variant="secondary" onClick={onConfirmFileOrders}>
                  Add orders
                </Button>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  onChange={fileHandler}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
